<div class="page-not-allowed">
  <mat-icon [icon]="'not-allowed'" [iconSize]="200" />
  <div class="page-not-allowed__container">
    <div class="page-not-allowed__container--header">{{ 'NotAllowed.Header' | transloco }}</div>
    @if (error) {
      <div class="page-not-allowed__container--text">
        {{ error | transloco }}
      </div>
    }
    <div class="page-not-allowed__container--sub">
      <div class="page-not-allowed__container--sub">{{ 'NotAllowed.Subheader' | transloco }}</div>
      &nbsp;
      <a class="page-not-allowed__container--link" href="https://www.treetop-medical.com/" target="_blank">Treetop Medical</a>
    </div>
    <div class="page-not-allowed__container--sub">
      <div class="page-not-allowed__container--sub">{{ 'NotAllowed.TryWithADifferentAccount' | transloco }}</div>
      &nbsp;
      <a class="page-not-allowed__container--link" [routerLink]="'/logout'">{{ 'NotAllowed.LogOut' | transloco }}</a>
    </div>
  </div>
</div>
